import Renderer from '../react_renderer';
import { UI } from '../legacy/ui';

// WARNING
// ~/dev/frontend/discovery-ui/src/components/addresses/checkout/shipping_address_selector.tsx:283
//
// rerenderTotals is exported and called directly from the checkout address book to force
// an address update, be sure changes to this function do not break checkout address
// selection behavior
function rerenderTotals(data, global = window, dom = document) {
  const $checkoutTotals = $(dom).find('[data-checkout-totals]');
  if ($checkoutTotals.length === 0) return;

  const url = $checkoutTotals.data('checkout-totals');

  const ajax = $.ajax({
    url,
    type: 'PUT',
    data,
  });

  UI.spin(ajax, $checkoutTotals).done((d) => {
    $checkoutTotals.html(d);
    Renderer.render(global, $checkoutTotals[0]);
  });
}

function init(global = window, dom = document) {
  $(dom).on(
    'change',
    ':input[data-update-checkout-totals], [data-update-checkout-totals] :input',
    () => {
      rerenderTotals(
        $(dom).find('form').serialize(),
        global,
        dom,
      );
    },
  );

  const $fetchTaxOnLoad = $(dom)
    .find('input[id=fetch_tax_on_load]');

  if ($fetchTaxOnLoad.length === 0 || $fetchTaxOnLoad.val() === 'false') {
    return;
  }

  rerenderTotals(
    $(dom).find('form').serialize(),
    global,
    dom,
  );
}

// Do not bind during tests, this causes test pollution
if (process.env.NODE_ENV !== 'test') {
  window.addEventListener('load', () => {
    init();
  });
}

export {
  init,
  rerenderTotals,
};



// WEBPACK FOOTER //
// ./javascripts/components/bundled_checkout/checkout_totals.js